import { makeStyles } from "@material-ui/core/styles";
import {THEME_SECONDARY_COLOR, THEME_PRIMARY_COLOR} from '../../Constants';

const screenWidth = window.innerWidth;

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
    paddingTop: '10px 0px'
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: '65% auto',
    // gridTemplateRows: 'auto auto auto auto',
    // gridTemplateAreas: '"header header" "images details" "images inclusions" "description"', //documents
    gridTemplateRows: 'auto',
    gridTemplateAreas: '"box0 box0" "box1 box2"',
    margin: theme.spacing(3, 6),
    gridGap: 20,
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: '100%',
      gridTemplateRows: 'auto auto auto auto',
      gridTemplateAreas: '"header" "images" "details" "inclusions" "description"', //documents
      margin: '24px auto'
    }
  },
  header: {
    width: '100%',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    gridArea: 'header'
  },
  images: {
    gridArea: 'images',
    alignSelf: 'baseline',
    width: '100%',
    [theme.breakpoints.up("sm")]: {
      marginBottom: theme.spacing(2)
    }
  },
  details: {
    gridArea: 'details',
    top: 0,
    [theme.breakpoints.up("sm")]: {
      position: '-webkit-sticky',
      position: 'sticky',
      maxHeight: '200px',
      marginBottom: theme.spacing(2)
    },
    // [theme.breakpoints.down("md")]: {
    //   maxHeight: 100
    // }
  },
  description: {
    gridArea: 'description',
    [theme.breakpoints.up("sm")]: {
      marginBottom: theme.spacing(2)
    }
  },
  inclusions: {
    gridArea: 'inclusions',
    [theme.breakpoints.up("sm")]: {
      marginBottom: theme.spacing(2)
    }
  },
  // documents: {
  //   gridArea: 'documents',
  //   alignSelf: 'baseline',
  //   '& a': {
  //     color: 'blue'
  //   },
  // [theme.breakpoints.up("sm")]: {
  //   marginBottom: theme.spacing(2)
  // }
  // },
  detailsGrid: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    '&> div': {
      flexGrow: 1,
      maxHeight: 250,
      marginBottom: 30
    },
    [theme.breakpoints.up("sm")]: {
      marginBottom: theme.spacing(2)
    }
  },
  carouselFlex: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '&> div': {
      marginBottom: 30
    }
  },
  nameFlex: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    '&> span': {
      color: `${THEME_SECONDARY_COLOR}`
    }
  },
  detailsFlex: {
    // minHeight: 200,
    height: '105%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    [theme.breakpoints.down("sm")]: {
      minHeight: 200
    },
  },
  detailsFlexForChat: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    // alignItems: 'baseline',
    // [theme.breakpoints.down("sm")]: {
    //   minHeight: 200
    // },
    // [theme.breakpoints.down("md")]: {
    //   alignItems: 'flex-start',
    //   justifyContent: 'flex-start',
    //   marginTop: 10
    // },
  },
  inclusionsFlex: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    '&> h6': {
      flexGrow: 1,
      width: '45%'
    }
  },
  button: {
    color: theme.palette.getContrastText(`${THEME_PRIMARY_COLOR}`),
    // backgroundColor: `${THEME_SECONDARY_COLOR}`,
    backgroundColor: `${THEME_PRIMARY_COLOR}`,
    color: '#fff',
    '&:hover': {
      backgroundColor: `${THEME_SECONDARY_COLOR}`,
      color: theme.palette.getContrastText(`${THEME_SECONDARY_COLOR}`)
    }
  },
  attachment: {
    float: 'left',
    fontSize: 20,
    marginRight: 10
  },
  editButton: {
    position: 'fixed',
    bottom: 20,
    right: 20
  },
  chatButton: {
    color: 'white',
    // fontSize: 16,
    // fontWeight: 'bold',
    backgroundColor: '#25D366',
    '&:hover': {
      backgroundColor: '#25D366',
    },
    [theme.breakpoints.down("sm")]: {
      display: 'none'
    },
    '& img': {
      width: 40,
      height: 40
    }
  },
  chatButtonMobile: {
    width: screenWidth - 32,
    color: 'white',
    fontSize: 16,
    fontWeight: 'bold',
    position: 'fixed',
    bottom: 0,
    left: 15,
    right: 15,
    zIndex: 999,
    backgroundColor: '#25D366',
    '&:hover': {
      backgroundColor: '#25D366'
    },
    '& img': {
      width: 40,
      height: 40
    },
    [theme.breakpoints.up("md")]: {
      display: 'none'
    }
  },
  visualIteneraryButton: {
    marginTop: 10
  },
  modalView: {
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '90vw',
    height: '90vh',
    [theme.breakpoints.down('sm')]: {
      width: '100vw',
      height: '80vh'
    }
  },
  newButton: {
    border: `2px solid ${THEME_PRIMARY_COLOR}`,
    color: `${THEME_PRIMARY_COLOR}`,
    backgroundColor: 'white',
    marginTop: 10,
    [theme.breakpoints.down('sm')]: {
      backgroundColor: `${THEME_PRIMARY_COLOR}`,
      color: 'white',
      marginTop: theme.spacing(2),
    },
    '&:hover': {
      backgroundColor: `${THEME_PRIMARY_COLOR}`,
      color: 'white'
    }
  },
  desktopFlexWrapper: {
    display: 'flex', flexDirection: 'column'
  },
  box0: {
    gridArea: "box0"
  },
  box1: {
    gridArea: "box1"
  },
  box2: {
    gridArea: "box2"
  }
}))

export default useStyles;
